import React from "react";
import { AccountBalance, CreditCard, AttachMoney } from "@mui/icons-material";
import { DailyBalance } from "../types";
import { PixBrandIcon } from "./PixBrandIcon";

export type BalancePaymentMethodKey = keyof DailyBalance["byPaymentMethod"];

/** Icon tint aligned with balance breakdown bar colors (PIX uses official brand mark) */
const ICON_COLORS: Record<Exclude<BalancePaymentMethodKey, "PIX">, string> = {
  Débito: "#16a34a",
  Crédito: "#9333ea",
  Dinheiro: "#ca8a04",
};

export function PaymentMethodBalanceIcon({
  method,
  size = 22,
}: {
  method: BalancePaymentMethodKey;
  size?: number;
}) {
  switch (method) {
    case "PIX":
      return <PixBrandIcon size={size} />;
    case "Débito":
      return <AccountBalance sx={{ fontSize: size, color: ICON_COLORS.Débito }} />;
    case "Crédito":
      return <CreditCard sx={{ fontSize: size, color: ICON_COLORS.Crédito }} />;
    case "Dinheiro":
      return <AttachMoney sx={{ fontSize: size, color: ICON_COLORS.Dinheiro }} />;
    default:
      return null;
  }
}
